export default "__VITE_ASSET__d5118fd7__"